export enum TrancheScheduleStatusTypeEnum {
	PENDING = "PENDING",
	DRAFT = "DRAFT",
	ACCEPTED = "ACCEPTED",
}